<template>
  <div class="card">
    <div class="card-body pb-1">
      <p class="m-0">
        <small class="font-weight-bold">{{ $t('dashboard.department') }}</small>
      </p>
      <highcharts :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { format, sub } from 'date-fns'
import Api from '@/utils/Api'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({
        period: 'daily',
        startDate: sub(new Date(), { days: 30 }),
        endDate: new Date()
      })
    },
    isApply: {
      type: Boolean,
      default: () => (false)
    }
  },

  data: () => ({
    chartOptions: {
      title: false,
      credits: false,
      chart: {
        type: 'variablepie',
        height: 348,
        margin: [0, 0, 60, 0]
      },
      tooltip: {
        headerFormat: '',
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
          'Total Submission by Department: <b>{point.y}</b><br/>'
      },
      plotOptions: {
        variablepie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          center: ['75%', '56%'],
          showInLegend: true
        }
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'middle',
        itemMarginTop: 10
      },
      series: [{
        innerSize: '30%',
        dataLabels: {
          enabled: true,
          format: '<b>{point.y}</b>',
          useHtml: false,
          color: '#3f377f',
          distance: 30
        },
        data: []
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
              itemMarginTop: 100
            },
            plotOptions: {
              variablepie: {
                center: ['50%', '50%']
              }
            }
          }
        }]
      }
    }
  }),

  computed: {
    builtFilters () {
      return [
        `period=${this.filters.period}`,
        `startDate=${format(this.filters.startDate, 'yyyy-MM-dd')}`,
        `endDate=${format(this.filters.endDate, 'yyyy-MM-dd')}`,
        ...this.filters.organization.map(organization => `organization=${organization}`),
        ...this.filters.workLocation.map(workLocation => `workLocation=${workLocation}`),
        ...this.filters.employee.map(employee => `employeeType=${employee}`),
        ...this.filters.risk.map(risk => `risk=${risk}`)
      ].join('&')
    }
  },

  watch: {
    isApply: {
      deep: true,
      immediate: true,
      handler: 'fetch'
    }
  },

  mounted () {
    this.fetch()
  },

  methods: {
    async fetch () {
      const { data } = await Api.dashboard.submissionDepartment(this.builtFilters)
      const keys = Object.keys(data)
      const values = Object.values(data)
      this.chartOptions.series[0].data = []
      for (let i = 0; i < Object.keys(data).length; i++) {
        this.chartOptions.series[0].data.push({
          name: keys[i],
          y: values[i]
        })
      }
    }
  }
}
</script>
